import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { partyQueries } from "@nexxt/party-ui";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the roles (50-api/party.md §2.2): all of them at once, with what each grants and denies and every
// permission a role can be given, and the history of one.

const roles = api.party.roles;

type Roles = InferResponseType<typeof roles.$get, 200>;
export type Role = Roles["items"][number];
export type Permission = Roles["permissions"][number];

/** The tabs of the page of a role, in the URL (`?tab=`). */
export const roleTabs = ["permissions", "field-rules", "delegation", "history"] as const;
export type RoleTab = (typeof roleTabs)[number];

const keys = { all: [...partyQueries.all, "roles"] as const };

export const roleQueries = {
  ...keys,

  list: () =>
    queryOptions({
      queryKey: [...keys.all, "list"],
      queryFn: ({ signal }) => unwrap(roles.$get({}, { init: { signal } })),
    }),

  history: (roleId: string) =>
    infiniteQueryOptions({
      queryKey: [...keys.all, "history", roleId],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          roles[":roleId"].history.$get(
            { param: { roleId }, query: pageParam ? { cursor: pageParam } : {} },
            { init: { signal } },
          ),
        ),
      initialPageParam: "",
      getNextPageParam: (last) => last.nextCursor ?? undefined,
    }),
};
